import axios from 'axios'

export const AdminPostalCodeService = {
  /**
   * @param {*} status blank is for both status(published and inactive)
   * status = 1 ==> for inactive
   * status = 2 ==> for published
   */
  fetchPostalCodeList (status = '') {
    if (status !== '') {
      return axios.get(`/api/v1/postalcodelist/${status}`)
    } else {
      return axios.get('/api/v1/postalcodelist')
    }
  },
  fetchJurisdictionListForPostalCodeItem (id = '') {
    if (id !== '') {
      return axios.get(`api/v1/jurisdictionpostalcodelist/${id}`)
    } else {
      return axios.get(`api/v1/jurisdictionpostalcodelist`)
    }
  },
  /**
   * edit postal code record
   */
  editPostalCodeItem (data) {
    return axios.post(`/api/v1/editpostalcode`, JSON.stringify({
      postalCode: data.postalCode,
      status: data.status,
      userId: data.userId,
      id: data.id
    }))
  },
  /**
   * Add new postal code record
   */
  addPostalCodeItem (data) {
    return axios.post(`/api/v1/addpostalcode`, JSON.stringify({
      postalCode: data.postalCode,
      status: data.status,
      userId: data.userId
    }))
  }
}
